import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { styled } from '@stitches/react';

export const DropdownMenuArrow = styled(DropdownMenu.Arrow, { fill: 'white' });
